import { createRouter, createWebHashHistory ,createWebHistory } from 'vue-router'

const DefaultContainer = () => import('../layouts/DefaultContainer');
import {FUNCTIONALITY_TYPES} from "@/constants/functionality-types";
const AppConfigCard = () => import('@/Cards/AppConfigCard');
const SearchApp = () => import('@/views/Search-App/SearchApp');
const Home = () => import('@/views/Home');
const Page404 = () => import('@/views/Pages/Page404');
const EntityListCard = () => import('@/Cards/EntityListCard');
const Playground = () => import('@/views/Playground');
const SearchConfig = () => import('@/views/Search/Search-Config');
const SynonymsList = () => import('@/views/synonyms/Synonyms-List');
const RedirectList = () => import('@/views/redirects/Redirect-List');
const CategoryConfig = () => import('@/views/category/CategoryConfig');
const WidgetConfig = () => import('@/views/widget/WidgetConfig');

const ConfigConfig = () => import('@/views/config/ConfigConfig');
const AssetsConfig = () => import('@/views/assets/AssetsConfig');
const MonitoringConfig = () => import('@/views/monitoring/MonitoringConfig');
const TextExtractConfig = () => import('@/views/textextract/TextExtractConfig');
const AliasConfig = () => import('@/views/alias/AliasConfig');
const IdMappingConfig = () => import('@/views/IdMapping/IdMappingConfig');
const TenantConfig = () => import('@/views/tenant/TenantConfig');
const RoleConfig = () => import('@/views/role/RoleConfig');
const FacetConfig = () => import('@/views/facet/FacetConfig');
const GenericListConfig = () => import('@/views/generic-lists/GenericListConfig');
const FeedingConfig = () => import('@/views/feeding/Feeding-Config');
const IndexConfig = () => import('@/views/index/Index-Config');
const AnalyzerConfig = () => import('@/views/analyzers/Analyzers-Config');
const SuggestConfig = () => import('@/views/suggest/Suggest-Config');
const VectorizerConfig = () => import('@/views/vectorizer/Vectorizer-Config');
const SecurityConfig = () => import('@/views/security/Security-Config');
const UserConfig = () => import('@/views/user/User-Config');
const ExportImportConfig = () => import('@/views/export-import/Export-Import-Config');
const ScheduleConfig = () => import('@/views/schedule/Schedule-Config.vue');
const ApiTestingConfig = () => import('@/views/api-testing/Api-Testing-Config');
const QscDashboard = () => import('@/views/QscDashboard');
const QscDashboardBeta = () => import('@/views/QscDashboardBeta');
const SystemMonitoringConfig = () => import('@/views/system-monitoring/System-Monitoring-Config');
const EntityManagerConfig = () => import('@/views/entity-manager/EntityManagerConfig');
const EntityManagerRaw = () => import('@/views/entity-manager/EntityManagerRaw');
const ComponentConfigManagerConfig = () => import('@/views/component-config-manager/ComponentConfigManagerConfig');
const QscSelectPlayground = () => import('@/views/Qsc-Select-Playground');
const routes = [
  {
    path: '/',
    name: 'Home',
    redirect: `/home`,
    component: DefaultContainer,
    children: [
      {
        path: `/dashboard/:tenant`,
        name: 'Dashboard',
        component: QscDashboard,
        meta: {
          baseAppUrl: '/dashboard',
          type: FUNCTIONALITY_TYPES.dashboard
        },
      },
      {
        path: `/dashboard-beta/:tenant/:config?`,
        name: 'DashboardBeta',
        component: QscDashboardBeta,
        meta: {
          baseAppUrl: '/dashboard-beta',
          type: FUNCTIONALITY_TYPES.dashboard
        },
      },
      {
        path : '/playground',
        name : 'playground',
        component : Playground,

      },
      {
        path : '/qsc-select-playground',
        name : 'qsc-select-playground',
        component : QscSelectPlayground,

      },
      {
        path: `/home`,
        name: 'Home',
        component: Home,
        meta: {
          baseAppUrl: '/home',
          type: FUNCTIONALITY_TYPES.home
        },
      },
    
   
   
      {
        path: '',
        redirect: `/home`,
        name :'AppConfigCard',
        component:AppConfigCard,
        children : [
          {
            path: '/searchapp/:tenant/:code',
            name: 'Search App',
            component: SearchApp,
            meta: {
              baseEndpointUrl: '/admin/searchapp',
              baseAppUrl: '/searchapp',
              type: FUNCTIONALITY_TYPES.searchApp,
              headerActions: {
                buttons: {
                  refresh: {
                    status: true
                  },
                  close: {
                    status: true
                  },
                  expert : {
                    status : true
                  }
                },
                menu: {
                  general: {
                    status: true,
                    showRaw: {
                      status: true
                    },
                  },
                }
              }
            },
          },
          {
            path: '/search/category/:tenant/:code',
            name: 'Category',
            meta: {
              baseEndpointUrl: '/admin/category',
              baseAppUrl: '/search/category',
              type: FUNCTIONALITY_TYPES.category,
              headerActions: {
                buttons: {
                  refresh: {
                    status: true
                  },
                  close: {
                    status: true
                  },
                },
              }
            },
            component: CategoryConfig,
          },
          {
            path: '/search/search/:tenant/:code',
            name: 'Search',
            component: SearchConfig,
            meta: {
              baseAppUrl: '/search/search',
              baseEndpointUrl: '/admin/search',
              type: FUNCTIONALITY_TYPES.search,
              headerActions: {
                buttons: {
                  refresh: {
                    status: true
                  },
                  close: {
                    status: true
                  },
                },
                menu: {
                  links: {
                    status: true
                  },
                }
              }
            }
          },
          {
            path: '/search/synonym/:tenant/:code',
            name: 'Synonym',

            component: SynonymsList,
            meta: {
              baseAppUrl: '/search/synonym',
              baseEndpointUrl: '/admin/synonym',
              type: FUNCTIONALITY_TYPES.synonym,
              headerActions: {
                buttons: {
                  refresh: {
                    status: true
                  },
                  close: {
                    status: true
                  },
                },
                menu: {
                  advanced: {
                    status: true,
                    import: {
                      status: true
                    },
                    exportAsLucene: {
                      status: true
                    },
                    exportAsCsv : {
                      status:true
                    },
                    exportAsJson : {
                      status:true
                    }
                  }
                },

              }
            },
          },
          {
            path: '/search/redirect/:tenant/:code',
            name: 'redirect',

            component: RedirectList,
            meta: {
              baseAppUrl: '/search/redirect',
              baseEndpointUrl: '/admin/redirect',
              type: FUNCTIONALITY_TYPES.redirect,
              headerActions: {
                buttons: {
                  refresh: {
                    status: true
                  },
                  close: {
                    status: true
                  },
                },
                menu: {
                  advanced: {
                    status: true,
                    import: {
                      status: true
                    },
                    export: {
                      status: true
                    }
                  }
                },
              }
            },
          },
          {
            path: '/list/:tenant/:code',
            name: 'list',
            meta: {
              baseEndpointUrl: '/admin/list',
              baseAppUrl: '/list',
              type: FUNCTIONALITY_TYPES.list,
              headerActions: {
                buttons: {
                  refresh: {
                    status: true
                  },
                  close: {
                    status: true
                  },
                },
                menu: {
                  general: {
                    status: true,
                    configuration: {
                      status: true
                    }
                  },
                  advanced: {
                    status: true,
                    import: {
                      status: true
                    },
                    exportAsCsv: {
                      status: true
                    },
                    exportAsJson: {
                      status: true
                    }
                  }
                },
              }
            },
            component: GenericListConfig,
          },
          {
            path: '/config/:tenant/:code',
            name: 'config',
            meta: {
              baseEndpointUrl: '/admin/config',
              baseAppUrl: '/config',
              type: FUNCTIONALITY_TYPES.config,
              headerActions: {
                buttons: {
                  refresh: {
                    status: true
                  },
                  close: {
                    status: true
                  },
                },

              }
            },
            component: ConfigConfig,
          },
          {
            path: '/assets/:tenant/:code',
            name: 'Assets',
            meta: {
              baseEndpointUrl: '/admin/assets',
              baseAppUrl: '/assets',
              type: FUNCTIONALITY_TYPES.assets,
              headerActions: {
                buttons: {
                  refresh: {
                    status: true
                  },
                  close: {
                    status: true
                  },
                },
              }
            },
            component: AssetsConfig,
          },
          {
            path: '/monitoring/:tenant/:code',
            name: 'Monitoring',
            meta: {
              baseEndpointUrl: '/admin/monitoring',
              baseAppUrl: '/monitoring',
              type: FUNCTIONALITY_TYPES.monitoring,
              headerActions: {
                buttons: {
                  refresh: {
                    status: true
                  },
                  close: {
                    status: true
                  },
                },
              }
            },
            component: MonitoringConfig,
          },
          {
            path: '/text-extract/:tenant/:code',
            name: 'Text Extract',
            meta: {
              baseEndpointUrl: '/admin/text-extract',
              baseAppUrl: '/text-extract',
              type: FUNCTIONALITY_TYPES.textExtract,
              headerActions: {
                buttons: {
                  refresh: {
                    status: true
                  },
                  close: {
                    status: true
                  },
                },
              }
            },
            component: TextExtractConfig,
          },
          {
            path: '/alias/:tenant/:code',
            name: 'Alias',
            meta: {
              baseEndpointUrl: '/admin/alias',
              baseAppUrl: '/alias',
              type: FUNCTIONALITY_TYPES.alias,
              headerActions: {
                buttons: {
                  refresh: {
                    status: true
                  },
                  close: {
                    status: true
                  },
                },
              }
            },
            component: AliasConfig,
          },
          {
            path: '/expimp/:tenant/:code',
            name: 'Export Import',
            component: ExportImportConfig,
            meta: {
              baseAppUrl: '/expimp',
              baseEndpointUrl: '/admin/expimp',
              type: FUNCTIONALITY_TYPES.expimp,
              headerActions: {
                buttons: {
                  refresh: {
                    status: true
                  },
                  close: {
                    status: true
                  }
                },
              }
            },
          },
          {
            path: '/user/:tenant/:code',
            name: 'User',
            meta: {
              baseEndpointUrl: '/admin/user',
              baseAppUrl: '/user',
              type: FUNCTIONALITY_TYPES.user,
              headerActions: {
                buttons: {
                  refresh: {
                    status: true
                  },
                  close: {
                    status: true
                  },
                },
              }
            },
            component: UserConfig,
          },
          {
            path: '/id-mapping/:tenant/:code',
            name: 'id-mapping',
            meta: {
              baseEndpointUrl: '/admin/id-mapping',
              baseAppUrl: '/id-mapping',
              type: FUNCTIONALITY_TYPES.idMapping,
              headerActions: {
                buttons: {
                  refresh: {
                    status: true
                  },
                  close: {
                    status: true
                  },
                },

              }
            },
            component: IdMappingConfig,
          },
          {
            path: '/tenant/:tenant/:code',
            name: 'tenantConfig',
            meta: {
              baseEndpointUrl: '/admin/tenant',
              baseAppUrl: '/tenant',
              type: FUNCTIONALITY_TYPES.tenant,
              headerActions: {
                buttons: {
                  refresh: {
                    status: true
                  },
                  close: {
                    status: true
                  },
                },

              }
            },
            component: TenantConfig,
          },
          {
            path: '/role/:tenant/:code',
            name: 'roleConfig',
            meta: {
              baseEndpointUrl: '/admin/role',
              baseAppUrl: '/role',
              type: FUNCTIONALITY_TYPES.role,
              headerActions: {
                buttons: {
                  refresh: {
                    status: true
                  },
                  close: {
                    status: true
                  },
                },

              }
            },
            component: RoleConfig,
          },
          {
            path: '/index/analyzer/:tenant/:code',
            name: 'Analyzer',
            component: AnalyzerConfig,
            meta: {
              baseAppUrl: '/index/analyzer',
              baseEndpointUrl: '/admin/analyzer',
              type: FUNCTIONALITY_TYPES.analyzer,
              headerActions: {
                buttons: {
                  refresh: {
                    status: true
                  },
                  close: {
                    status: true
                  },
                },
              }
            }
          },
          {
            path: '/facet/:tenant/:code',
            name: 'facetConfig',
            meta: {
              baseEndpointUrl: '/admin/facet',
              baseAppUrl: '/facet',
              type: FUNCTIONALITY_TYPES.facet,
              headerActions: {
                buttons: {
                  refresh: {
                    status: true
                  },
                  close: {
                    status: true
                  },
                },

              }
            },
            component: FacetConfig,
          },
          {
            path: '/search/suggest/:tenant/:code',
            name: 'Suggest',
            component: SuggestConfig,
            meta: {
              baseAppUrl: '/search/suggest',
              baseEndpointUrl: '/admin/suggest',
              type: FUNCTIONALITY_TYPES.suggest,
              headerActions: {
                buttons: {
                  refresh: {
                    status: true
                  },
                  close: {
                    status: true
                  },
                },
              }
            }
          },
          {
            path: '/index/vectorizer/:tenant/:code',
            name: 'Vectorizer',
            component: VectorizerConfig,
            meta: {
              baseAppUrl: '/index/vectorizer',
              baseEndpointUrl: '/admin/vectorizer',
              type: FUNCTIONALITY_TYPES.vectorizer,
              headerActions: {
                buttons: {
                  refresh: {
                    status: true
                  },
                  close: {
                    status: true
                  },
                },
              }
            }
          },
          {
            path: '/security/:tenant/:code',
            name: 'Security',
            id: 'security',
            meta: {
              baseEndpointUrl: '/admin/security',
              baseAppUrl: '/security',
              type: FUNCTIONALITY_TYPES.security,
              headerActions: {
                buttons: {
                  refresh: {
                    status: true
                  },
                  close: {
                    status: true
                  },
                },
              }
            },
            component: SecurityConfig,
          },
          {
            path: '/feeding/:tenant/:code',
            name: 'feedingConfig',
            meta: {
              baseEndpointUrl: '/admin/feeding',
              baseAppUrl: '/feeding',
              type: FUNCTIONALITY_TYPES.feeding,
              headerActions: {
                buttons: {
                  refresh: {
                    status: true
                  },
                  close: {
                    status: true
                  },
                },

              }
            },
            component: FeedingConfig,
          },
          {
            path: '/index/index-storage/:tenant/:code',
            name: 'Index',
            meta: {
              baseAppUrl: '/index/index-storage',
              baseEndpointUrl: '/admin/index-storage',
              type: FUNCTIONALITY_TYPES.index,
              headerActions: {
                buttons: {
                  refresh: {
                    status: true
                  },
                  close: {
                    status: true
                  },
                },
              }
            },
            component: IndexConfig,
          },
          {
            path: '/schedule/:tenant/:code',
            name: 'Schedule',
            component: ScheduleConfig,
            meta: {
              baseEndpointUrl: '/admin/schedule',
              baseAppUrl: '/schedule',
              type: FUNCTIONALITY_TYPES.schedule,
              headerActions: {
                buttons: {
                  refresh: {
                    status: true
                  },
                  close: {
                    status: true
                  },
                },
              }
            },
          },
          {
            path: '/monitoring/system-monitoring/:tenant',
            name: 'System Monitoring',
            id: 'system-monitoring',
            meta: {
              finalUrl: '/monitoring/system',
              baseAppUrl: '/monitoring/system-monitoring',
              type: FUNCTIONALITY_TYPES.systemMonitoring,
              headerActions: {
                buttons: {
                  refresh: {
                    status: true
                  },
                },
              }
            },
            component: SystemMonitoringConfig,
          },
          {
            path: '/api-testing/:tenant/:code',
            name: 'ApiTesting',
            id: 'api-testing',
            meta: {
              baseEndpointUrl: '/admin/api-testing',
              baseAppUrl: '/api-testing',
              type: FUNCTIONALITY_TYPES.apiTesting,
              headerActions: {
                buttons: {
                  refresh: {
                    status: true
                  },
                  close: {
                    status: true
                  },
                },
                menu: {
                  links: {
                    status: true
                  }
                }
              }
            },
            component: ApiTestingConfig,
          },
          {
            path: '/widget/:tenant/:code',
            name: 'widget',
            component: WidgetConfig,
            meta: {
              baseEndpointUrl: '/admin/widget',
              baseAppUrl: '/widget',
              type: FUNCTIONALITY_TYPES.widget,
              headerActions: {
                buttons: {
                  refresh: {
                    status: true
                  },
                  close: {
                    status: true
                  },
                },
    
              }
            },
          },
        ]
      },
      {
        path: "entity-manager/:tenant",
        name: "EntityManagerConfig",
        component: EntityManagerConfig,
        meta: {
          baseAppUrl: "/entity-manager",
          type: FUNCTIONALITY_TYPES.entityManager
        }

      },
      {
        path: "component-config-manager/:tenant",
        name: "componentConfigManager",
        component: ComponentConfigManagerConfig,
        meta: {
          type: FUNCTIONALITY_TYPES.componentConfigManager
        }

      },
      {
        path: "entity-manager/:tenant/:type/:code",
        name: "EntityManagerRaw",
        component: EntityManagerRaw

      },

      {
        path: '/search/search/:tenant',
        name: ' SearchList',
        component: EntityListCard,
        meta: {
          type: FUNCTIONALITY_TYPES.search,
          baseEndpointUrl: '/admin/search',
          baseAppUrl: '/search/search',
          mode: 'list'
        }
      },
      {
        path: '/user/:tenant',
        name: 'User List',
        component: EntityListCard,
        meta: {
          type: FUNCTIONALITY_TYPES.user,
          baseEndpointUrl: '/admin/user',
          baseAppUrl: '/user',
          mode: 'list'
        }
      },
      {
        path: '/widget/:tenant',
        name: 'Widget List',
        component: EntityListCard,
        meta: {
          type: FUNCTIONALITY_TYPES.widget,
          baseEndpointUrl: '/admin/widget',
          baseAppUrl: '/widget',
          mode: 'list'
        }
      },
      {
        path: '/search/category/:tenant',
        name: 'CategoryList',
        component: EntityListCard,
        meta: {
          type: FUNCTIONALITY_TYPES.category,
          baseEndpointUrl: '/admin/category',
          baseAppUrl: '/search/category',
          mode: 'list'
        }
      },
      {
        path: '/search/synonym/:tenant/',
        name: 'SynonymsList',

        component: EntityListCard,
        meta: {
          type: FUNCTIONALITY_TYPES.synonym,
          baseEndpointUrl: '/admin/synonym',
          baseAppUrl: '/search/synonym',
          mode: 'list',
        },


      },
      {
        path: '/search/redirect/:tenant/',
        name: 'RedirectList',
        component: EntityListCard,
        meta: {
          type: FUNCTIONALITY_TYPES.redirect,
          baseEndpointUrl: '/admin/redirect',
          baseAppUrl: '/search/redirect',
          mode: 'list',
        },
      },

      {
        path: '/searchApp/:tenant',
        name :'searchAppList',
        component:EntityListCard,
        meta: {
          type: FUNCTIONALITY_TYPES.searchApp,
          baseEndpointUrl: '/admin/searchapp',
          baseAppUrl: '/searchapp',
          mode: 'list'
        },

      },
      {
        path: '/list/:tenant',
        name: 'List',
        component: EntityListCard,
        meta: {
          type: FUNCTIONALITY_TYPES.list,
          baseEndpointUrl: '/admin/list',
          baseAppUrl: '/list',
          mode: 'list'
        }
      },
      {
        path: '/config/:tenant',
        name: 'ConfigList',
        component: EntityListCard,
        meta: {
          type: FUNCTIONALITY_TYPES.config,
          baseEndpointUrl: '/admin/config',
          baseAppUrl: '/config',
          mode: 'list'
        }
      },
      {
        path: '/assets/:tenant',
        name: 'AssetsConfigList',
        component: EntityListCard,
        meta: {
          type: FUNCTIONALITY_TYPES.assets,
          baseEndpointUrl: '/admin/assets',
          baseAppUrl: '/assets',
          mode: 'list'
        }
      },
      {
        path: '/monitoring/:tenant',
        name: 'MonitoringConfigList',
        component: EntityListCard,
        meta: {
          type: FUNCTIONALITY_TYPES.monitoring,
          baseEndpointUrl: '/admin/monitoring',
          baseAppUrl: '/monitoring',
          mode: 'list'
        }
      },
      {
        path: '/text-extract/:tenant',
        name: 'TextExtractConfigList',
        component: EntityListCard,
        meta: {
          type: FUNCTIONALITY_TYPES.textExtract,
          baseEndpointUrl: '/admin/text-extract',
          baseAppUrl: '/text-extract',
          mode: 'list'
        }
      },
      {
        path: '/alias/:tenant',
        name: 'AliasConfigList',
        component: EntityListCard,
        meta: {
          type: FUNCTIONALITY_TYPES.alias,
          baseEndpointUrl: '/admin/alias',
          baseAppUrl: '/alias',
          mode: 'list'
        }
      },
      {
        path: '/id-mapping/:tenant',
        name :'idMappingList',
        component:EntityListCard,
        meta: {
          type: FUNCTIONALITY_TYPES.idMapping,
          baseEndpointUrl: '/admin/id-mapping',
          baseAppUrl: '/id-mapping',
          mode: 'list'
        },

      },
      {
        path: '/tenant/:tenant',
        name :'tenantList',
        component:EntityListCard,
        meta: {
          type: FUNCTIONALITY_TYPES.tenant,
          baseEndpointUrl: '/admin/tenant',
          baseAppUrl: '/tenant',
          mode: 'list'
        },

      },
      {
        path: '/role/:tenant',
        name :'roleList',
        component:EntityListCard,
        meta: {
          type: FUNCTIONALITY_TYPES.role,
          baseEndpointUrl: '/admin/role',
          baseAppUrl: '/role',
          mode: 'list'
        },

      },
      {
        path: '/facet/:tenant',
        name :'facetList',
        component:EntityListCard,
        meta: {
          type: FUNCTIONALITY_TYPES.facet,
          baseEndpointUrl: '/admin/facet',
          baseAppUrl: '/facet',
          mode: 'list'
        },

      },
      {
        path: '/feeding/:tenant',
        name :'feedingList',
        component:EntityListCard,
        meta: {
          type: FUNCTIONALITY_TYPES.feeding,
          baseEndpointUrl: '/admin/feeding',
          baseAppUrl: '/feeding',
          mode: 'list'
        },

      },
      {
        path: '/index/index-storage/:tenant',
        name: 'Index List',
        component: EntityListCard,
        meta: {
          type: FUNCTIONALITY_TYPES.index,
          baseEndpointUrl: '/admin/index-storage',
          baseAppUrl: '/index/index-storage',
          mode: 'list'
        }
      },
      {
        path: '/index/analyzer/:tenant',
        name: 'Analyzer List',
        component: EntityListCard,
        meta: {
          type: FUNCTIONALITY_TYPES.analyzer,
          baseEndpointUrl: '/admin/analyzer',
          baseAppUrl: '/index/analyzer',
          mode: 'list'
        }
      },
      {
        path: '/expimp/:tenant',
        name: 'Export Import List',
        component: EntityListCard,
        meta: {
          type: FUNCTIONALITY_TYPES.expimp,
          exportImportHeaderComponent: 'export-import-header',
          baseEndpointUrl: '/admin/expimp',
          baseAppUrl: '/expimp',
          mode: 'list'
        }
      },
      {
        path: '/index/vectorizer/:tenant',
        name: 'Vectorizer List',
        component: EntityListCard,
        meta: {
          type: FUNCTIONALITY_TYPES.vectorizer,
          baseEndpointUrl: '/admin/vectorizer',
          baseAppUrl: '/index/vectorizer',
          mode: 'list'
        }
      },

      {
        path: '/search/suggest/:tenant',
        name: 'Suggest List',
        component: EntityListCard,
        meta: {
          type: FUNCTIONALITY_TYPES.suggest,
          baseEndpointUrl: '/admin/suggest',
          baseAppUrl: '/search/suggest',
          mode: 'list'
        }
      },
      {
        path: '/security/:tenant',
        name: 'Security List',
        component: EntityListCard,
        meta: {
          type: FUNCTIONALITY_TYPES.security,
          baseEndpointUrl: '/admin/security',
          baseAppUrl: '/security',
          mode: 'list'
        }
      },
      {
        path: '/schedule/:tenant',
        name: 'Schedule List',
        component: EntityListCard,
        meta: {
          type: FUNCTIONALITY_TYPES.schedule,
          baseEndpointUrl: '/admin/schedule',
          baseAppUrl: '/schedule',
          mode: 'list'
        }
      },
      {
        path: '/api-testing/:tenant',
        name: 'ApiTesting List',
        component: EntityListCard,
        meta: {
          type: FUNCTIONALITY_TYPES.apiTesting,
          baseEndpointUrl: '/admin/api-testing',
          baseAppUrl: '/api-testing',
          mode: 'list'
        }
      },
    ]
  },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  },
  {
    path: '/:pathMatch(.*)*',
    name: '404Page',
    component: Page404
  },
]

const router = createRouter({

  history: createWebHistory(process.env.BASE_URL),
  routes,
  linkActiveClass: 'open active',
  scrollBehavior: () => ({y: 0}),
})

export default router
